export { WishlistsModel } from './wish-list.model';
